import { render, staticRenderFns } from "./Terms-Use.vue?vue&type=template&id=4cdcf62e&scoped=true&"
import script from "./Terms-Use.vue?vue&type=script&lang=js&"
export * from "./Terms-Use.vue?vue&type=script&lang=js&"
import style0 from "./Terms-Use.vue?vue&type=style&index=0&id=4cdcf62e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4cdcf62e",
  null
  
)

export default component.exports